import React from 'react';
import { Accordion } from '@withjoy/joykit';
import { createDisplayName } from '@withjoy/joykit/utils';
import { COMPONENT_BY_FACET_VARIANT } from './components';
import type { RefinementFacetProps } from './RefinementFacet.types';
import { ProductCatalogAttributeSelectionType } from '@graphql/generated-base';
import { useRegistryCatalogFiltersOpenDefaultEnabled } from '../../hooks/useRegistryCatalogFiltersOpenDefaultEnabled';

export const RefinementFacet = (props: RefinementFacetProps & { defaultIsOpen: boolean }) => {
  const { filter, onFilterSelect, defaultIsOpen, checkIsFilterGroupViewExpanded, toggleGroupFullyExpand } = props;
  const { filterSelectionType } = props.filter.attributeGroup;
  const isNotPriceRangeFilter = filterSelectionType !== ProductCatalogAttributeSelectionType.priceRange;

  const { registryCatalogFiltersOpenDefaultEnabled } = useRegistryCatalogFiltersOpenDefaultEnabled({ skipIf: isNotPriceRangeFilter });
  const shouldOpenAccordion = defaultIsOpen || registryCatalogFiltersOpenDefaultEnabled ? 0 : undefined;

  if (!filter.attributes.length && isNotPriceRangeFilter) {
    return null;
  }

  const Variant = COMPONENT_BY_FACET_VARIANT[filterSelectionType];

  if (!Variant) {
    return null;
  }

  return (
    <Accordion defaultIndex={shouldOpenAccordion}>
      <Variant
        filter={filter}
        onFilterSelect={onFilterSelect}
        checkIsFilterGroupViewExpanded={checkIsFilterGroupViewExpanded}
        toggleGroupFullyExpand={toggleGroupFullyExpand}
      />
    </Accordion>
  );
};

RefinementFacet.Skeleton = ({ variant }: { variant: string }) => {
  const Variant = COMPONENT_BY_FACET_VARIANT[variant as ProductCatalogAttributeSelectionType];

  if (!Variant || !Variant.Skeleton) {
    return null;
  }

  return (
    <Accordion defaultIndex={0}>
      <Variant.Skeleton />
    </Accordion>
  );
};

RefinementFacet.displayName = createDisplayName('RefinementFacet');
